import { createSelector } from '@reduxjs/toolkit';
import { selectIsSuburbanListing } from '../jsonQuery';
import { EXTENDED_TERMS_TO_RESET, TERMS_TO_RESET } from '../../../packages/Tags';

export const selectTagsToReset = createSelector(selectIsSuburbanListing, isSuburbanListing =>
  isSuburbanListing ? TERMS_TO_RESET : EXTENDED_TERMS_TO_RESET,
);
